import { Constants } from '../utils/constants';

/**
 * 10Gアップグレードの受付可否を判定する
 * APIから返却されるアップグレード可否フラグをもとに、
 * アップグレード可能（UPGRADEOK）または不可（NOTUPGRADENG）を返す。
 *
 * @param upgradable_g10_flg アップグレード可否フラグ（APIレスポンスから取得）
 * @returns アップグレード可否の判定結果定数
 */
export const judgeAcceptance = (upgradable_g10_flg: string) => {
  const acceptanceupgrade = upgradable_g10_flg;

  if (acceptanceupgrade) {
    // アップグレード対象の場合
    if (acceptanceupgrade === Constants.UpgradesearchAcceptanceJudgement.UPGRADE) {
      return Constants.Upgrade.UPGRADEOK;
    }
    // アップグレード非対象の場合
    if (acceptanceupgrade === Constants.UpgradesearchAcceptanceJudgement.NOTUPGRADE) {
      return Constants.Upgrade.NOTUPGRADENG;
    }
  }
  // フラグが未設定の場合はアップグレード不可として扱う
  return Constants.Upgrade.NOTUPGRADENG;
};

export default judgeAcceptance;
